@if (toc) {
  <button
    class="relative flex gap-xs items-center border-none outline-none surface-container-lowest text-left corner-m cursor-pointer p-b-2xs p-i-s max-w-full"
    (click)="openSideSheet()"
    [attr.id]="'toc-trigger-' + toc.id"
  >
    @if (isAdaptive) {
      <dcr-animated-kai class="icon-size-xl shrink-0" [src]="'kai_state_machine.riv' | assetsPath: 'rive'" autoplay></dcr-animated-kai>
    }
    <span class="flex flex-column cursor-inherit min-w-0">
      @if (toc.parent) {
        <span class="label-large on-surface-variant truncate">{{ toc.parent.title }}</span>
      }
      <span class="title-large on-surface truncate">{{ toc.title }}</span>
    </span>

    @if (active) {
      <dcr-icon icon="shared:right-panel-open"></dcr-icon>
    }
    <dcr-state-layer [for]="'toc-trigger-' + toc.id"></dcr-state-layer>
    <dcr-focus-ring [for]="'toc-trigger-' + toc.id"></dcr-focus-ring>
  </button>
} @else {
  <dcr-filled-button trailing-icon="shared:right-panel-open" (click)="openSideSheet()" label="Kies een les"></dcr-filled-button>
}
